import { loggedIn } from '../lib';

export default () => {
  const t = {
    SMALL: 3,
    MEDIUM: 4,
    LARGE: 5
  };

  const calculateProductSize = (numberOfProducts) => {
    if (numberOfProducts > t.MEDIUM) {
      return t.SMALL;
    }
    else if (numberOfProducts < t.MEDIUM) {
      return t.LARGE;
    }
    return t.MEDIUM;
  };

  $('.owl-carousel.saved-products').each((index, carousel) => {
    const $carousel = $(carousel);
    const $products = $('.saved-product', $carousel);
    const numberOfProducts = $products.length;
    const productSize = calculateProductSize(numberOfProducts);
    $carousel.addClass(`saved-products__${numberOfProducts}-col`);
    $carousel.owlCarousel({
      items: 1,
      loop: false,
      margin: 20,
      nav: true,
      navText: ['', ''],
      stagePadding: 10,
      dotsEach: 1,
      responsiveRefreshRate: 10,
      responsive: {
        0: {
          margin: 20,
          stagePadding: 40
        },
        375: {
          margin: 20,
          stagePadding: 50
        },
        480: {
          items: productSize > t.MEDIUM ? 1 : 2,
          stagePadding: 12
        },
        840: {
          items: productSize > t.MEDIUM ? 2 : 3
        },
        1025: {
          items: productSize > t.SMALL ? numberOfProducts : 4
        },
        1280: {
          items: Math.min(numberOfProducts, 5)
        }
      }
    });
  });
};

export const setSavedProductsCount = (numberOfSavedProducts) => {
  if (loggedIn()) {
    $('.user-menu__saved').text(numberOfSavedProducts);
  }
};
